import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 表示箇所のサイズ！
        width: null,
        height: null,
        // 実質定数
        pcAspect: 1.44043,
        spAspect: 0.49019,
        scroll: 0,
        isScroll: false,
        // 詳細画面を開いてるかどうか
        isDetail: false,
        // 詳細画面に表示する画像
        detailImg: ''
    },
    getters: {
        getWidth(state) {
            return state.width
        },
        getHeight(state) {
            return state.height
        },
        // 縦横どっちをサイズの基準にするか
        getAspect(state) {
            let aspect = state.width / state.height
            if (state.width >= 980) {
                return aspect >= state.pcAspect ? 'width' : 'height'
            } else {
                return aspect >= state.spAspect ? 'width' : 'height'
            }
        },
        getScrollNum(state) {
            return state.scroll;
        },
        getScroll(state) {
            return state.isScroll
        },
        getIsDetail(state) {
            return state.isDetail
        },
        // 画像を取得
        getDetail(state) {
            return state.detailImg
        }
    },
    mutations: {
        setWidth(state, payload) {
            state.width = payload
        },
        setHeight(state, payload) {
            state.height = payload
        },
        setScrollNum(state) {
            state.scroll = window.pageYOffset
        },
        setScrollTrue(state) {
            state.isScroll = true
        },
        setScrollFalse(state) {
            state.isScroll = false
        },
        setDetailTrue(state) {
            state.isDetail = true
        },
        setDetailFalse(state) {
            state.isDetail = false
        },
        setDetailImg(state, payload) {
            state.detailImg = payload.image
        },
    },
    actions: {
        setHeight({
            commit
        }) {
            commit('setHeight', window.innerHeight)
        },
        setWidth({
            commit
        }) {
            commit('setWidth', window.innerWidth)
        },
        setScrollNum({
            commit
        }) {
            commit('setScrollNum')
        },
        setScrollTrue({
            commit
        }) {
            commit('setScrollTrue')
        },
        setScrollFalse({
            commit
        }) {
            commit('setScrollFalse')
        },
        setDetailTrue({
            commit
        }) {
            commit('setDetailTrue')
        },
        setDetailFalse({
            commit
        }) {
            commit('setDetailFalse')
        },
        // クリックしたときに表示される部分の画像をセット
        setDetailImg({
            commit
        }, image) {
            commit('setDetailImg', {
                image
            })
        }
    }
})